"use strict"



// Пример запуска: showAlertSuccess({pos: 'top center', autoclose:2000})
function showAlertSuccess({
	title = 'Сообщение отправлено', 
	body = 'Мы свяжемся с Вами в ближайшее время',
	className = '', 
	pos = 'center center',
	backdrop = true,
	hasClose = true,
	autoclose = false
} = {}) {
	DD.log('showAlertSuccess', title, body)
	new placeHTML({
		type: 'alert',
		placeIn: 'stack',
		stackPosition: pos,
		title: title,
		body: body,
		backdrop: backdrop,
		class: 'alert-success ' + className,
		hasClose: hasClose,
		autoClose: autoclose
	})
}


function showAlertError({
	title = 'Произошла ошибка', 
	body = 'Ваше сообщение не отправлено. Пожалуйста, свяжитесь с нами любым удобным способом.', 
	className = '', 
	pos = 'center center',
	backdrop = true,
	hasClose = true,
	autoclose = false
} = {}) {
	DD.log('showAlertError', title, body)
	new placeHTML({
		type: 'alert',
		placeIn: 'stack',
		stackPosition: pos,
		title: title,
		body: body,
		backdrop: backdrop,
		class: 'alert-danger ' + className,
		hasClose: hasClose,
		autoClose: autoclose
	})
}


function formHandlerDefault($formSelector) {
	const formEl = document.querySelector($formSelector)
	if (!formEl) console.error(`ERR formHandlerDefault: форма:${$formSelector} не найдена`)

	if (window.site.TPLA.length) {
		// loadResources(window.site.TPLA + "/js/imask.min.js")
		// 	.then(() => {
		// 		const phoneEl = formEl.querySelector('input[type="tel"]')
		// 		IMask(phoneEl, {
		// 			mask: '+{000} (00) 000-00-00'
		// 		})
		// 	})
	}

	new fsubmit({
		form: formEl,
		onSuccess: () => {
			showAlertSuccess()
			openModal = bootstrap.Modal.getInstance(document.querySelector('.modal.show')); if (openModal) openModal.hide();
		},
		onError: (error) => {
			showAlertError()
		},
	})
}


// обработка agree-privacy
function formAgreePrivacyHandler($formSelector, $checkFormValidity = true) {
	const formEl = document.querySelector($formSelector)
	const checkTerms = formEl.querySelector('.form-agree-privacy')
	const submitBtn = formEl.querySelector('.btn_submit')

	if(!checkTerms || !submitBtn) console.error(`ERR formAgreePrivacyHandler: форма:${$formSelector} не найдена`)

	const submitBtnHandlerEvent = () => {
		const isAgreeTerms = checkTerms.checked;
		const isFormValid = $checkFormValidity ? formEl.checkValidity() : true;
		const isButtonEnabled = isAgreeTerms && isFormValid;
		DD.log(isAgreeTerms, isFormValid, isButtonEnabled)

		submitBtn.disabled = !isButtonEnabled
		submitBtn.classList.toggle('disabled', !isButtonEnabled)
	}
	formEl.addEventListener('input', submitBtnHandlerEvent)
	formEl.addEventListener('change', submitBtnHandlerEvent)
	formEl.dispatchEvent(new CustomEvent('input'))
}


document.addEventListener('DOMContentLoaded', () => {
	if (window.site.TPLA.length) {
		const items = document.querySelectorAll('[data-fancybox]')
		if (items.length) {
			items.forEach(item => { item.dataset.fancyboxReady = 'true' })

			loadResources([
				window.site.TPLA + '/js/fancybox.umd.js',
				window.site.TPLA + '/css/fancybox.min.css',
			]).then(() => {
				DD.log('fancybox-ready')
				Fancybox.bind("[data-fancybox]")
			}).catch((e) => console.error(e))
		}
	}
})


window.addEventListener('load', () => { 
	setTimeout(() => {
		AOS.init({
			once: true
		});
	}, 100)
});
